const $header = $('header');
const $body = 'body';
const isMobile = () => {
  return !$('.rnk-container-menu ul.rnk-componente-menu').is(':visible');
};
$(window).scroll(function () {
  var scroll = $(window).scrollTop();
  if (scroll > 0 && scroll >= 70) {
    $($body).addClass('scrolling');
  } else {
    $($body).removeClass('scrolling');
  }
  if (scroll >= 350) {
    $header.addClass('shadowHeader');
  } else {
    $header.removeClass('shadowHeader');
  }
  if ($('body').hasClass('breadcrumb-fixed') == true && isMobile() == true) {
    $header.removeClass('shadowHeader');
  }
});
export default {};
